import { Box, styled, Typography } from '@mui/material';
import { Expert, Tag } from '@/types/collection';
import { ReactComponent as BagIcon } from '@/assets/images/bag.svg';
import { useState } from 'react';

const Container = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  gap: 8,
}));

const ProductsButton = styled('button')(() => ({
  all: 'unset',
  width: 'fit-content',
  cursor: 'pointer',
  display: 'flex',
  backgroundColor: 'white',
  color: 'black',
  userSelect: 'none',
  zIndex: 10,
  borderRadius: 40,
  paddingInline: 6,
  paddingBlock: 4,
  gap: 6,
  fontSize: 16,
  lineHeight: '20px',
  fontWeight: 600,
  transition: 'opacity 0.2s ease',
  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.5)',

  '@media (any-hover: hover)': {
    '&:hover': {
      opacity: 0.8,
    },
  },
}));

const VerticalLine = styled(Box)(({ theme }) => ({
  width: 1,
  height: '100%',
  backgroundColor: theme.palette.border.main,
}));

const AvatarContainer = styled('button')(() => ({
  all: 'unset',
  gap: 8,
  zIndex: 10,
  width: 'fit-content',
  cursor: 'pointer',
  userSelect: 'none',
  display: 'flex',
  alignItems: 'center',
  transition: 'opacity 0.2s ease',

  '@media (any-hover: hover)': {
    '&:hover': {
      opacity: 0.8,
    },
  },
}));

const Avatar = styled('img')(() => ({
  width: 32,
  height: 32,
  borderRadius: '50%',
}));

type Props = {
  onClick: (element: string) => void;
  productsCount: number;
  expert: Expert;
  description: string;
  tags: Tag[];
};

export default function CollectionLeftSide({
  onClick,
  productsCount,
  expert,
  description,
  tags,
}: Props) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Container>
      <ProductsButton onClick={() => onClick('See products')}>
        <BagIcon />
        {productsCount}
        <VerticalLine />
        See products
      </ProductsButton>
      <AvatarContainer onClick={() => onClick(expert.displayName)}>
        <Avatar src={expert.avatarUrl} alt={expert.displayName} />
        <Typography
          fontSize={16}
          fontWeight={600}
          lineHeight="20px"
          color="white"
          sx={{ textShadow: '0px 1px 2px rgba(0, 0, 0, 0.5)' }}
        >
          {expert.displayName}
        </Typography>
      </AvatarContainer>
      <Typography
        fontSize={16}
        fontWeight={600}
        lineHeight="20px"
        color="white"
        onClick={() => setExpanded(!expanded)}
        sx={{
          zIndex: 10,
          display: '-webkit-box',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          cursor: 'pointer',
          textShadow: '0px 1px 2px rgba(0, 0, 0, 0.5)',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: expanded ? 'unset' : 2,
          whiteSpace: expanded ? 'normal' : 'unset',
        }}
      >
        {description} {tags.map((item) => `#${item.name}`).join(' ')}
      </Typography>
    </Container>
  );
}
